module.exports = __webpack_public_path__ + "static/media/promo-banner-mobile.ad61dd37.webp";